export const fetchAiSpecSuggestions = async (options) => {
    const {productName, categoryName, specData, token, cb, clickTrack, keywordId, unitOfMeasurement, filledSpecs, description, isPricePresent, imageUrlArr = [], isFromAI = false } = options;
    const { default:{ post, get } } = await import('axios');
    const getFilteredSpecs = () => {
        const filterableSpecs = specData.filter(spec => spec.s_filter_flag == 1);
        const nonFilterableSpecs = specData.filter(spec => spec.s_filter_flag != 1);
        let filteredSpecs = [];
        if(isFromAI) {
            const mandatorySpecs = specData.filter(spec => spec.s_mandatory == 1);
            const nonMandatorySpecs = specData.filter(spec => spec.s_mandatory != 1);
            filteredSpecs = [...mandatorySpecs, ...nonMandatorySpecs];
        }else {
            filteredSpecs = [...filterableSpecs,...nonFilterableSpecs];
        }
        return filteredSpecs;
    }
    const data = {
        productName: productName,
        keywordName: categoryName,
        specData: getFilteredSpecs(),
    }
    const params = {
        action:         'getSpecValue',
        token:          token
    }
    clickTrack();
    let requestArr = [];
    if(!isPricePresent) {
        const bodyData = {
            product_name: productName,
            keyword_name: categoryName,
            keyword_id: keywordId,
            unit_of_measurment: unitOfMeasurement || '',
            product_specs: JSON.stringify(Object.assign({}, ...filledSpecs)),
            description: description || ''
        }
        let formData = new FormData();
        Object.keys(bodyData).map(key => {
            formData.append(key,bodyData[key]);
        })
        requestArr.push(post('/vendorapis/products/b2bwebsite/getaiprice',formData));
    } else {
        requestArr.push(Promise.resolve({data: {}}));
    }
    if(specData.length) {
        requestArr.push(post('/marketplace/static/php/web/b2bWebsite.php', data , { params }));
    }else {
        requestArr.push(Promise.resolve({data: {}}))
    }
    const results = await Promise.allSettled(requestArr);
    const [res1, res2] = results;

     let resultData = {};

     if (res1.status === 'fulfilled' && res1.value?.data) {
        resultData['priceData'] = res1.value.data;
    } else {
        console.log('First API failed:', res1.reason);
    }

    if (res2.status === 'fulfilled') {
        const response = res2.value;
        if (response?.data?.status === 1 && response?.data?.msg === '') {
            resultData = {...resultData,...response.data};
        } else {
            console.log('fetchAiSpecSuggestions error in response', response?.msg, response?.data);
        }
    } else {
        console.log('Second API failed:', res2.reason);
    }
    cb && cb(resultData);
  
};